// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-gallery[data-v-16fa9d36] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.image-box[data-v-16fa9d36] {\n  position: relative;\n}\n.image-box .del-btn[data-v-16fa9d36] {\n  position: absolute;\n  right: 10px;\n  top: -20px;\n  color: red;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
